// @flow
import styled from "styled-components";

export const SpinnerContainer = styled.div`
    text-align: center;
    margin-top: 25px;
`;

export const Spacer = styled.div`
    height: 25px;
`;

export const Photos = styled.div`
    line-height: 0;
    text-align: left;
`;

export const Overlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    padding-top: 25px;
    width: 100%;
`;
export const Month = styled.div`
    background-size: cover;
    background-position: center 32%;
    background-repeat: no-repeat;
    width: 50%;
    height: 10vw;
    min-height: 125px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid #fff;
    box-sizing: border-box;

    @media only screen and (min-width: 768px) {
        width: 33%;
    }
`;

export const TitleText = styled.div`
    color: #fff;
    text-align: left;
    padding: 25px;
    font-weight: bold;
    background: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 0.2) 30px);
`;



// WEBPACK FOOTER //
// ./src/photos-page-view/styled.js